export default {
    outlined: {
      zIndex: 0,
    }
};
